module.exports = __webpack_public_path__ + "img/japan.ce5fd254.svg";